/* aw-koop.js — de koopknop krijgt de prijs erachter, zoals de bron.
 *
 * De bron zet in de knop twee stukken: "Add to cart >" en daarachter de prijs
 * van de gekozen variant ("£41.95"), met een kleinere letterspatie op de prijs
 * (0,56 tegen 1,96). Horizons knop heeft alleen een label en een winkelwagen-
 * icoontje.
 *
 * De prijs komt uit het prijsblok op de pagina; die wordt door Horizon zelf
 * ververst bij een variantwissel, dus dan klopt de knop vanzelf mee.
 */
(() => {
  /* De bron zet "Add to cart >" in één span en de prijs in een tweede, met 8px
     ertussen via de flex-gap van de knop. Het pijltje krijgt bij ons een eigen
     span zodat het — op verzoek van de eigenaar — net als de prijs iets zachter
     kan staan dan het woord ervoor. */
  const PIJL = '>';

  function prijsNu() {
    const el = document.querySelector('.aw-prijs__nu');
    if (!el) return '';
    /* De verborgen tekst "Sale price" staat in dezelfde knoop; die hoort er
       niet bij. */
    const verborgen = el.querySelector('.visually-hidden');
    const ruw = el.textContent || '';
    return (verborgen ? ruw.replace(verborgen.textContent, '') : ruw).trim();
  }

  let bijwerken = function () {
    const knop = document.querySelector('add-to-cart-component button, .add-to-cart-button');
    if (!knop) return;
    const p = prijsNu();
    if (!p) return;

    let label = knop.querySelector('.aw-atc-label');
    if (!label) {
      /* De tekstknoop van Horizon opzoeken en in een eigen span zetten, zodat
         we hem los van het icoontje kunnen opmaken. */
      const tekstKnoop = [...knop.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
      label = document.createElement('span');
      label.className = 'aw-atc-label';
      label.textContent = tekstKnoop ? tekstKnoop.textContent.trim() : 'Add to cart';
      const pijl = document.createElement('span');
      pijl.className = 'aw-atc-pijl';
      /* De spatie zit IN het pijltje en niet als losse tekstknoop ervoor. Dat
         moet: het label is een flexdoos, en een tekstknoop die alleen uit witruimte
         bestaat valt daarin weg. Gemeten gevolg: het label was 120,7 breed waar de
         bron 126,4 is, en op het scherm plakte het pijltje tegen "CART" aan.
         Een vaste spatie is een echt teken, krijgt dus ook de letterspatie mee, en
         komt daarmee precies op de breedte van de bron uit. */
      pijl.textContent = '\u00A0' + PIJL;
      label.appendChild(pijl);
      if (tekstKnoop) tekstKnoop.replaceWith(label); else knop.appendChild(label);
    }
    let prijs = knop.querySelector('.aw-atc-prijs');
    if (!prijs) {
      prijs = document.createElement('span');
      prijs.className = 'aw-atc-prijs';
      label.after(prijs);
    }
    if (prijs.textContent !== p) prijs.textContent = p;
  };

  function foutregel() {
    /* Horizon houdt de foutregel altijd in de opmaak. Wij verbergen hem in de
       CSS en zetten hem alleen terug als er echte tekst in staat. */
    document.querySelectorAll('.product-form-text__error').forEach((el) => {
      const heeftTekst = (el.textContent || '').trim().length > 0;
      el.classList.toggle('aw-fout-zichtbaar', heeftTekst);
    });
  }

  const oudeBijwerken = bijwerken;
  bijwerken = function () { oudeBijwerken(); foutregel(); };

  /* ── de knop mag geen moment kaal staan ──────────────────────────────────
   *
   * DE KLACHT. "Als ik een kleur kies zie ik heel kort alleen ADD TO CART."
   *
   * DE OORZAAK. Horizon haalt na een variantwissel een VERSE knop op en zet die
   * in de plaats. Alles wat wij eraan hangen — het pijltje en het bedrag — is
   * dan weg. Herstellen op vaste momenten (een timer van 120ms, of een lus van
   * 800ms) helpt niet: de hertekening komt over het netwerk en landt dus meestal
   * ná dat moment. Tussen die twee zit het gat dat je ziet.
   *
   * DE OPLOSSING, overgenomen van The Hills waar dit al gemeten is: herstellen
   * op de GEBEURTENIS in plaats van op de klok, met een waarnemer op de sectie.
   *
   * Twee sloten tegen zichzelf aanroepen — onze eigen toevoegingen zijn immers
   * óók wijzigingen in die kolom:
   *   1. we doen alleen iets als er ECHT iets ontbreekt; is de knop compleet,
   *      dan keren we meteen terug;
   *   2. tijdens ons eigen schrijven staat de waarnemer los.
   * Dezelfde val als in aw-variant.js, waar een waarnemer op zijn eigen
   * schrijfactie vuurde en de pagina niet meer klaarlaadde. */
  function ietsOntbreekt() {
    const knoppen = [...document.querySelectorAll('add-to-cart-component button')];
    return knoppen.some((k) => !k.querySelector('.aw-atc-prijs') || !k.querySelector('.aw-atc-label'));
  }

  let waarnemer = null;
  function bewaken() {
    const blok = document.querySelector('.product-information') ||
                 document.querySelector('[id^="shopify-section-"]');
    if (!blok || waarnemer) return;
    waarnemer = new MutationObserver(() => {
      if (!ietsOntbreekt()) return;
      waarnemer.disconnect();
      bijwerken();
      waarnemer.observe(blok, { childList: true, subtree: true });
    });
    waarnemer.observe(blok, { childList: true, subtree: true });
  }

  bijwerken();
  bewaken();
  document.addEventListener('change', () => setTimeout(bijwerken, 60), true);
  document.addEventListener('shopify:section:load', () => { bijwerken(); bewaken(); });
})();
